import { render, staticRenderFns } from "./NotiCardItem.vue?vue&type=template&id=a38035b6&"
import script from "./NotiCardItem.vue?vue&type=script&lang=js&"
export * from "./NotiCardItem.vue?vue&type=script&lang=js&"
import style0 from "./NotiCardItem.vue?vue&type=style&index=0&id=a38035b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports